import React, {useContext} from 'react';
import "./insights.scss";
import { AppContext } from '../../services/translationContext';
import { InsightsSection } from '../../components/sections/insights/insights';
import { ClientStoriesSection } from '../../components/sections/client-stories/client-stories';
import { PageHero } from '../../components/page-hero/page-hero';
import { useParams } from 'react-router-dom';
import SeoHelmet from '../../components/SeoHelmet';

export const Insights = () => {
  const { lang } = useParams();
  const { services: {TranslationsService} } = useContext(AppContext);

  const pageTitle = `${TranslationsService.labels(`menu.insights.label`)} | ${TranslationsService.getMainInfoCompany('name')}`;
  const pageDescription = TranslationsService.labels('hero_sections.insights.text');
  const pageUrl = `https://www.sydea.com/${lang}/insights`;

  const collectionSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: TranslationsService.labels(`menu.insights.label`),
    description: pageDescription,
    url: pageUrl,
    inLanguage: lang === 'it' ? 'it-IT' : 'en-US',
    mainEntity: {
      "@id": "https://www.sydea.com/#organization"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `https://www.sydea.com/${lang}` },
      { "@type": "ListItem", position: 2, name: TranslationsService.labels(`menu.insights.label`), item: pageUrl }
    ]
  };

  return (
    <div className="section-home light">

      <SeoHelmet
        title={pageTitle}
        description={pageDescription}
        image={TranslationsService.labels('hero_sections.insights.img_path')}
        schema={[collectionSchema, breadcrumbSchema]}
      />

      <PageHero
        bgImage={TranslationsService.labels('hero_sections.insights.img_path')}
        breadcrumb={[]}
        title={TranslationsService.labels(`menu.insights.label`)}
        subtitle={TranslationsService.labels(`hero_sections.insights.text`)}
        hideBreadcrumb={true}
      />
      <div className='container'>
        <InsightsSection />
      </div>
      {
        TranslationsService.childMenuAvailable('insightsSections.client-stories') && 
        <div className='syd-bg-dark'>
          <ClientStoriesSection />
        </div>
      }
    </div>
  );
};
